import template from './leadOpportunityCard.html';
import controller from './leadOpportunityCardCtrl';
import './style.scss';

export default {
  template,
  controller,
  bindings: {
    isSmallDevice: '<',
    card: '<',
    isSingle: '<',
    isShowTimeline: '<',
    timelineStatusList: '<',
    onChangeCardStatus: '&',
    isCorporateUser: '<',
    labelsSettings: '<',
    onLabelToggle: '&',
    onRefreshLabelsSettings: '&',
    isShrink: '<',
    isCompact: '<',
    onMenuClick: '&',
    onViewBorrower: '&',
    onViewLoanApp: '&',
    onDuplicateLoan: '&',
    onViewSubmission: '&',
    onViewLoanInformation: '&',
    onCardClick: '&',
    onToggleIsShrink: '&',
    onDeletePipelineItem: '&',
    probabilityList: '<',
    onChangeProbability: '&',
    onChangeSubStatus: '&',
    onLeadAddNote: '&',
    conversionOptions: '<',
    onConvertCard: '&',
    onViewOpportunity: '&',
    loanLendingCategories: '<',
    isMergeLeadAndOpportunities: '<',
    isBidViewFileEnabled: '<?',
    isPipeline: '<',
  },
};
